import { Box, SxProps } from '@mui/system';
import StepItem from './StepItem';

const StepList = ({
  sx,
  imgSx,
  list,
}: {
  sx?: SxProps;
  imgSx?: { width?: string | number; height?: string | number };
  list: {
    img: string;
    label: string;
    isCompleted?: boolean;
    isProgress?: boolean;
  }[];
}) => {
  return (
    <Box display={'flex'} justifyContent={'space-between'} sx={sx}>
      {list.map(step => (
        <StepItem
          {...step}
          styles={{ opacity: step.isProgress ? 1 : 0.5 }}
          imgStyles={{
            width: imgSx?.width,
            height: imgSx?.height,
          }}
        />
      ))}
    </Box>
  );
};

export default StepList;
